import React from 'react';
import styled from 'styled-components/macro';
import { observer } from 'mobx-react';
import { AnimatePresence, motion } from 'framer-motion';

import { useDataStore } from 'state/DataStore';


const ShortlistViewButton = observer(() => {
    const { shortlistStore } = useDataStore();
    const apartmentText = shortlistStore.shortlistedCount === 1 ? 'apartment' : 'apartments';
    
    return (
        <AnimatePresence>
            {shortlistStore.shortlistedCount > 0 && (
                <Container
                    initial={{ y: '-100%', opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: '-100%', opacity: 0 }}
                    transition={{
                        type: "spring",
                        duration: 0.3,
                    }}
                >
                    <StyledButton onClick={() => shortlistStore.openPopup()}>
                        <Count>{shortlistStore.shortlistedCount}</Count>
                        <Divider />
                        <Text className='h6'>{apartmentText} shortlisted</Text>
                    </StyledButton>
                </Container>
            )}
        </AnimatePresence>
    );
});


export default ShortlistViewButton;


const Container = styled(motion.div)`
    position: absolute;
    top: 0;
    z-index: 100;
`;

const StyledButton = styled.button`
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 2rem;
    padding: 1.25rem 2.5rem;
    
    background: #EDEDED;
    border: none;
    cursor: pointer;
    transition: all 0.3s ease;
    
    &:hover {
        background: ${props => props.theme.secondary_color_mid};
    }
`;

const Divider = styled.div`
    height: 3rem;
    width: .1rem;
    background-color: ${props => props.theme.secondary_color};
`;

const Count = styled.div`
    color: white;
    background-color: ${props => props.theme.primary_color};
    padding: .5rem 1rem;
    line-height: 1;
`;

const Text = styled.div``;
